// frontend/src/features/campaign/components/common/CampaignRoleBanner.js
import React from 'react';

export default function CampaignRoleBanner({ userRoleLabel, roleAccessText }) {
  return (
    <div className="cmp-role-access-banner">
      <i className="fas fa-user-tie" />
      <span>
        <strong>{userRoleLabel} access:</strong> {roleAccessText}
      </span>
    </div>
  );
}
